/**
 * Display rules for the figures on a shift that only exist once someone has
 * closed the shift and counted the drawer.
 *
 * `closing_cash` and `variance` are null on an open shift. NumberFormat turns
 * null into "0.00", so the shift detail dialog announced "Closing Cash 0" and
 * "Variance 0" for a shift nobody had counted yet — one reads as "the drawer
 * was empty", the other as "it balanced perfectly" — while the shifts table
 * showed "-" for that same shift, because DataTable guards those columns
 * (QRIPO-424). These keep the two views telling the same story.
 */

/** What the shifts table already prints for a figure that has no value yet. */
export const NOT_COUNTED = "-";

/**
 * @param {*} value the raw figure off the shift
 * @param {(value: *) => string} format the app's NumberFormat filter
 */
export function shiftStatValue(value, format) {
  if (value === null || value === undefined || value === "") {
    return NOT_COUNTED;
  }
  return format(value);
}

/**
 * An uncounted shift gets neither the good nor the bad colour. The old
 * `(variance || 0) >= 0` painted a null variance green, which reads as
 * "counted, and it balanced".
 */
export function shiftVarianceClass(variance) {
  if (variance === null || variance === undefined || variance === "") {
    return "";
  }
  return Number(variance) >= 0
    ? "detail-stat--positive"
    : "detail-stat--negative";
}
